import { jsx } from "panel";
import { ButtonEl } from "common/components/button";
import { DropMenuEl } from "common/components/drop-menu";
import { ItemsMenuEl } from "common/components/items-menu";
import { TagEl } from "common/components/tag";
import { ButtonTheme } from "common/components/button/constants";
export function template() {
  const {
    open
  } = this.state;
  return /* @__PURE__ */ jsx("div", { sel: ".complex-filter", "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx("div", { sel: ".complex-filter-display" }, /* @__PURE__ */ jsx(ButtonEl, { attrs: {
    icon: "filter",
    theme: ButtonTheme.Tertiary
  }, on: {
    click: this.helpers.clickedFilterButton
  }, "data-sentry-element": "ButtonEl", "data-sentry-source-file": "template.tsx" }, "Filter", /* @__PURE__ */ jsx(TagEl, { sel: ".complex-filter-count", attrs: {
    "tag-name": this.helpers.getSelectedItems().length.toString()
  }, "data-sentry-element": "TagEl", "data-sentry-source-file": "template.tsx" }))), /* @__PURE__ */ jsx(DropMenuEl, { attrs: {
    open
  }, on: {
    change: this.helpers.handleMenuChange
  }, "data-sentry-element": "DropMenuEl", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx(ItemsMenuEl, { attrs: {
    sections: this.attr("sections"),
    multiple: true
  }, on: {
    clickItem: this.helpers.handleFilterItemClick
  }, "data-sentry-element": "ItemsMenuEl", "data-sentry-source-file": "template.tsx" })));
}
